import './sass/main.scss';
// import './scripts/fetch'; // Tego nie importujemy na początku
import './scripts/footer';
import './scripts/modal_films';
import './scripts/loader';
import './scripts/search_movies';
import './scripts/auth';
